module.exports = __webpack_public_path__ + "img/waiting.c3bb6290.gif";